// @ts-nocheck
import Typography from "@insite/mobius/Typography";
import StyleguideCheckboxes from "@store/Library/Components/Toolkit/Styleguide/components/Forms/StyleguideCheckboxes";
import StyleguideDatePickers from "@store/Library/Components/Toolkit/Styleguide/components/Forms/StyleguideDatePickers";
import StyleguideDropdowns from "@store/Library/Components/Toolkit/Styleguide/components/Forms/StyleguideDropdowns";
import StyleguideDynamicDropdowns from "@store/Library/Components/Toolkit/Styleguide/components/Forms/StyleguideDynamicDropdowns";
import StyleguideFileUploads from "@store/Library/Components/Toolkit/Styleguide/components/Forms/StyleguideFileUploads";
import StyleguideRadios from "@store/Library/Components/Toolkit/Styleguide/components/Forms/StyleguideRadios";
import StyleguideTextAreas from "@store/Library/Components/Toolkit/Styleguide/components/Forms/StyleguideTextAreas";
import StyleguideTextFields from "@store/Library/Components/Toolkit/Styleguide/components/Forms/StyleguideTextFields";
import StyleguideAccordions from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideAccordions";
import StyleguideBreadcrumbs from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideBreadcrumbs";
import StyleguideButtons from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideButtons";
import StyleguideDataTables from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideDataTables";
import StyleguideIcons from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideIcons";
import StyleguideInfosBox from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideInfosBox";
import StyleguideModals from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideModals";
import StyleguideOverflowMenus from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideOverflowMenus";
import StyleguidePaginations from "@store/Library/Components/Toolkit/Styleguide/components/StyleguidePaginations";
import StyleguideTabs from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideTabs";
import StyleguideTags from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideTags";
import StyleguideToasts from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideToasts";
import StyleguideTooltips from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideTooltips";
import StyleguideTypographies from "@store/Library/Components/Toolkit/Styleguide/components/StyleguideTypographies";
import React, { FC } from "react";

const Styleguide: FC = () => {
    return (
        <>
            <Typography variant="h1">Styleguide</Typography>
            <StyleguideAccordions />
            <StyleguideBreadcrumbs />
            <StyleguideButtons />
            <StyleguideCheckboxes />
            <StyleguideDatePickers />
            <StyleguideDataTables />
            <StyleguideDropdowns />
            <StyleguideDynamicDropdowns />
            <StyleguideFileUploads />
            <StyleguideIcons />
            <StyleguideInfosBox />
            <StyleguideModals />
            <StyleguideOverflowMenus />
            <StyleguidePaginations />
            <StyleguideRadios />
            <StyleguideTabs />
            <StyleguideTags />
            <StyleguideTextAreas />
            <StyleguideTextFields />
            <StyleguideToasts />
            <StyleguideTooltips />
            <StyleguideTypographies />
        </>
    );
};

export default Styleguide;
